module.exports = __webpack_public_path__ + "img/SWP_Shield_09 (1).68d3a14f.png";